var _circle, _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDistance = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0001 9.99541C22.0001 8.34109 23.3432 7 25.0001 7C26.6569 7 28.0001 8.34109 28.0001 9.99541C28.0001 11.6497 26.6569 12.9908 25.0001 12.9908C23.3432 12.9908 22.0001 11.6497 22.0001 9.99541ZM20.0001 19.9801H30.0001C30.3467 19.9791 30.668 19.7989 30.8493 19.504C31.0306 19.209 31.046 18.8414 30.8901 18.5323L29.9401 16.6352C29.4301 15.6247 28.3933 14.9874 27.2601 14.9878H22.7401C21.6068 14.9874 20.57 15.6247 20.0601 16.6352L19.1101 18.5323C18.9541 18.8414 18.9695 19.209 19.1508 19.504C19.3321 19.7989 19.6535 19.9791 20.0001 19.9801ZM27.6101 36.977H31.5001C31.643 36.9632 31.7853 37.0089 31.8933 37.1035C32.0012 37.1981 32.0652 37.333 32.0701 37.4763V41.3603C32.0776 41.565 31.9566 41.7527 31.767 41.8306C31.5773 41.9086 31.3591 41.8604 31.2201 41.7098L30.2201 40.7113C28.4688 42.6353 25.7927 43.4297 23.2731 42.7735C20.7536 42.1173 18.8071 40.119 18.2201 37.5861C18.1923 37.4385 18.2286 37.286 18.3201 37.1668C18.4134 37.0464 18.5576 36.9762 18.7101 36.977H19.7101C19.9217 36.9714 20.1139 37.0993 20.1901 37.2966C20.6811 39.0496 22.0889 40.3969 23.8639 40.8124C25.6389 41.228 27.4998 40.6459 28.7201 39.2935L27.2601 37.8257C27.12 37.6831 27.0786 37.4709 27.1547 37.2861C27.2309 37.1014 27.41 36.9799 27.6101 36.977Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 29,
    height: 13,
    rx: 6.5,
    fill: "white",
    fillOpacity: 0.3
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDistance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Distance.d82d109a.svg";
export { ForwardRef as ReactComponent };